// extracted by mini-css-extract-plugin
export default {"container":"title_container__bK7uJ","title":"title_title__+4spN","selected":"title_selected__L7cmk","triangle":"title_triangle__8ykpG"};